var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCourseOverview = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.924 361.499)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.077 36.501)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-40.7-391L-40.7-391c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.4v8     c0,0.3,0.2,0.5,0.5,0.5c1.8-0.1,3.5,0.6,4.8,1.8v-8.4c0-0.1,0-0.2-0.1-0.3C-37.2-390.7-39.5-391-40.7-391z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-29.8-382.5v-8c0-0.3-0.2-0.5-0.5-0.5l0,0c-1.2,0-3.5,0.3-4.7,2.2c0,0.1-0.1,0.2-0.1,0.3v8.4     c1.3-1.2,3-1.8,4.8-1.8C-30.1-381.9-29.8-382.2-29.8-382.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-28.6-389.2H-29v6.7c0,0.8-0.6,1.4-1.4,1.4c-1.5-0.1-2.9,0.4-4,1.4c1.9-0.4,3.8-0.3,5.7,0.1     c0.3,0.1,0.6-0.1,0.6-0.4c0,0,0-0.1,0-0.1v-8.5C-28.1-388.9-28.3-389.2-28.6-389.2L-28.6-389.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-42.1-382.5v-6.7h-0.4c-0.3,0-0.5,0.2-0.5,0.5v8.5c0,0.3,0.2,0.5,0.5,0.5c0,0,0.1,0,0.1,0     c1.9-0.5,3.8-0.5,5.7-0.1c-1.1-0.9-2.6-1.4-4-1.4C-41.5-381.1-42.1-381.7-42.1-382.5z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCourseOverview, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-course-overview.7e74ee7c.svg";
export { ForwardRef as ReactComponent };